import React from 'react';
import Modal from '../../../../molecules/Modal';
import TextWithReferences from '../../TextWithReferences/TextWithReferences';

type Properties = {
    imagePath: string,
    toggleExpandCoach: () => void,
    coachName: string,
    message: string,
    isHidden: boolean
};

const CoachMessagePopup = (props: Properties) => {
    if (props.isHidden) {
        return <></>;
    }

    const message = <TextWithReferences text={props.message} />;

    const getImage = React.useCallback(() => {
        const image = require(`../../../../../static/i-pregno/coaches/${props.imagePath}`);
        return image;
    }, [props.imagePath]);

    return (
        <Modal alignItems="flex-end">
            <div className="page-coach" data-testid="coach-message-popup">
                <div className="coach-expanded">
                    <div className="coach-message">
                        <p className="read"><strong>{props.coachName}:</strong><br />{message}</p>
                    </div>
                    <div className="coach-image"><img src={getImage()} /></div>
                    <button className="dismiss-coach icon-button" onClick={props.toggleExpandCoach} data-testid="dismiss-coach-button">
                        OK
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default CoachMessagePopup;
